export default "__VITE_ASSET__22ed19a7__"